var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import classNames from "classnames";
export default function Button(_a) {
    var className = _a.className, _b = _a.variant, variant = _b === void 0 ? "default" : _b, children = _a.children, rest = __rest(_a, ["className", "variant", "children"]);
    return (React.createElement("button", __assign({ className: classNames("h-12 w-full rounded-sm border border-current font-semibold leading-none", {
            "bg-current": variant === "default",
            "bg-transparent": variant === "outlined",
            "text-trellis-black": !rest.disabled,
            "text-gray-100": rest.disabled,
        }, className) }, rest),
        React.createElement("span", { className: classNames("opacity-100", {
                "text-white": variant === "default",
                "text-current": variant === "outlined",
            }) }, children)));
}
